// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getAuth} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB8BmLXlRnGI_-4LcqgluvyzdTQrm7Gh1Y",
  authDomain: "sumarist-acb3d.firebaseapp.com",
  projectId: "sumarist-acb3d",
  storageBucket: "sumarist-acb3d.firebasestorage.app",
  messagingSenderId: "984767918588",
  appId: "1:984767918588:web:1ba58f8d095b4b40974279"
};
// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth();
export const db = getFirestore(app);